export default __webpack_public_path__ + "static/media/frpmc.00156876.png";